import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {VnaCampaignService} from '../../../vna-campaign/services/vna-campaign.service';
import {PortalService} from '../../../vna_portal/model/PortalService';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-call-center-parameters',
  templateUrl: './call-center-parameters.component.html',
  styleUrls: ['./call-center-parameters.component.scss']
})
export class CallCenterParametersComponent implements OnInit {

    @Input() portalService: PortalService;

    form: FormGroup;
    enabled: boolean = false;
    submitted: boolean = false;

    constructor(private fb: FormBuilder, private campHandler: VnaCampaignService, private alertHandler: AlertaService) {
        this.form = this.fb.group({
            is_call_center: new FormControl('0'),
            clic_to_call : new FormControl('0'),
            call_center_agents: new FormControl(1),
            call_center_timezone: new FormControl()
        });
    }

    save(): void {
        this.submitted = false;

        if(!this.form.valid){
            this.submitted = true;
            return;
        }

        let criteria = { 'portal_pk' : this.portalService.pkPortal, 'service_pk' : this.portalService.pkService, 'camp_pk' : this.portalService.pkCamp };

        this
            .campHandler
            .savePortalService(criteria, 'call_center_parameters', this.portalService.alias, this.form.value)
            .subscribe( result =>{
                this.enabled = false;
                this.alertHandler.addAlert('success','Call center configuration have been saved successfully')
            })

    }

    ngOnInit() {
        this.form.controls['is_call_center'].setValue(this.portalService.getConfigKey('is_call_center', '0').toString());
        this.form.controls['clic_to_call'].setValue(this.portalService.getConfigKey('clic_to_call', '0').toString());
        this.form.controls['call_center_agents'].setValue(this.portalService.getConfigKey('call_center_agents', 1));
        this.form.controls['call_center_timezone'].setValue(this.portalService.getConfigKey('call_center_timezone', ''));
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/call-center-parameters/call-center-parameters.component.ts